document.addEventListener('DOMContentLoaded', function () {
    function getSubscriptionCheckbox() {
      return document.querySelector('.subscription-checkbox');
    }

    function updatePriceDisplay(isSubscription) {
      // Get all variant pills
      const variantPills = document.querySelectorAll('.variant-pill-container');

      variantPills.forEach((pill) => {
        const originalPrice = pill.querySelector('.original-variant-price');
        const subscriptionPrice = pill.querySelector('.subscription-price');
        const subscriptionComparePrice = pill.querySelector('.subscription-compare-price');
        if (isSubscription) {
          if (originalPrice) originalPrice.style.display = 'none';
          if (subscriptionPrice) subscriptionPrice.style.display = 'block';
          if (subscriptionComparePrice) subscriptionComparePrice.style.display = 'block';
        } else {
          if (originalPrice) originalPrice.style.display = 'block';
          if (subscriptionPrice) subscriptionPrice.style.display = 'none';
          if (subscriptionComparePrice) subscriptionComparePrice.style.display = 'none';
        }
      });
    }

    // Initialize on page load
    function initializeSellingPlan() {
      const subscriptionCheckbox = getSubscriptionCheckbox();
      const sellingPlanInput = document.getElementById('selling-plan');
      
      if (!subscriptionCheckbox || !sellingPlanInput) return;
      
      if (subscriptionCheckbox.checked) {
        const firstRadio = document.querySelector('input[type="radio"][name="quantity"]');
        if (firstRadio) {
          const sellingPlanId = firstRadio.getAttribute('data-selling-plan-id');
          if (sellingPlanId) {
            sellingPlanInput.value = sellingPlanId;
          }
        }
        updatePriceDisplay(true);
      }
    }

    // Call initialization
    initializeSellingPlan();

    document.querySelectorAll('input[type="radio"][name="quantity"]').forEach((radio) => {
      radio.addEventListener('change', function () {
        const sellingPlanInput = document.getElementById('selling-plan');
        const subscriptionCheckbox = getSubscriptionCheckbox();

        if (!sellingPlanInput || !subscriptionCheckbox) return;

        if (!subscriptionCheckbox.checked) {
          sellingPlanInput.value = '';
          return;
        }

        const sellingPlanId = this.getAttribute('data-selling-plan-id');
        console.log(sellingPlanId)
        if (!sellingPlanId) return;

        sellingPlanInput.value = sellingPlanId;
      });
    });

    document.addEventListener('change', function (e) {
      if (!e.target.classList.contains('subscription-checkbox')) return;

      const sellingPlanInput = document.getElementById('selling-plan');
      if (!sellingPlanInput) return;

      const isChecked = e.target.checked;
      updatePriceDisplay(isChecked);

      if (!isChecked) {
        sellingPlanInput.value = '';
        return;
      }

      const selectedRadio = document.querySelector('input[type="radio"][name="quantity"]:checked');
      if (!selectedRadio) return;

      const sellingPlanId = selectedRadio.getAttribute('data-selling-plan-id');
      if (!sellingPlanId) return;

      sellingPlanInput.value = sellingPlanId;
    });
    
    const variantSelects = document.querySelectorAll('variant-selects');
    variantSelects.forEach((element) => {
      element.updateURL = function () {
        return;
      };
    });
});